import { trigger, state, style, transition, animate } from '@angular/animations';
import { AfterViewInit, Component, HostBinding, input, OnDestroy } from '@angular/core';
import { IconComponent } from "../icons/icon.component";
import { IconNameType } from '../icons/icon-name-type.enum';
import { TranslocoDirective } from '@ngneat/transloco';

@Component({
  selector: 'cwo-scroll-to-top',
  standalone: true,
  imports: [IconComponent, TranslocoDirective],
  templateUrl: './scroll-to-top.component.html',
  styleUrl: './scroll-to-top.component.scss',
  animations: [
    trigger('fadeInOut', [
      state('true', style({ opacity: 1, display: 'flex' })),
      state('false', style({ opacity: 0, display: 'none' })),
      transition('false => true', animate('300ms ease-in')),
      transition('true => false', animate('300ms ease-out'))
    ])
  ],
})
export class ScrollToTopComponent implements AfterViewInit, OnDestroy {
  scrollContainer = input<HTMLElement | null>(null);
  iconNameType = IconNameType;
  hostVisible = false;
  bottomOffset = input<number>(0);

  @HostBinding('style.bottom') get bottom() {
    return this.bottomOffset() - 2 + 'px';
  }

  ngAfterViewInit(): void {
    if (this.scrollContainer()) {
      this.scrollContainer()?.addEventListener('scroll', () => {
        this.onContainerScroll();
      });
    }
  }

  ngOnDestroy(): void {
    this.scrollContainer()?.removeEventListener('scroll', () => {
      this.onContainerScroll();
    });
  }


  @HostBinding('@fadeInOut') get animationState() {
    return this.hostVisible;
  }

  scrollToTop() {
    if (this.scrollContainer()) {
      this.scrollContainer()?.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  onContainerScroll() {
    if (!this.scrollContainer()) return;
    const scrollTop = this.scrollContainer()?.scrollTop ?? 0;
    this.hostVisible = scrollTop > 100;
  }

}
